(window as any).videoPlayer = {
    async play(video: HTMLVideoElement) {
        try {
            await video?.play();
            return true;
        } catch (err) {
            console.warn(err);
            return false;
        }
    },
    pause(video: HTMLVideoElement) {
        try {
            video?.pause();
            return true;
        } catch (err) {
            console.warn(err);
            return false;
        }
    },
    getCurrentTime(video: HTMLVideoElement): number {
        return video.currentTime;
    },
    setCurrentTime(video: HTMLVideoElement, time: number) {
        try {
            const duration = video.duration;
            if (!isNaN(duration) && !isNaN(time) && time >= 0 && time <= duration) {
                video.currentTime = Math.max(0, time);
            }
            return true;
        } catch (err) {
            console.warn(err);
            return false;
        }
    },
    seekToEnd(video: HTMLVideoElement) {
        try {
            const duration = video.duration;
            if (!isNaN(duration)) {
                video.currentTime = Math.max(0, duration - 3);
            }
            return true;
        } catch (err) {
            console.warn(err);
            return false;
        }
    },
    getDuration(video: HTMLVideoElement): number {
        return video.duration;
    },
    setPlaybackRate(video: HTMLVideoElement, rate: number) {
        try {
            video.playbackRate = rate;
            return true;
        } catch (err) {
            console.warn(err);
            return false;
        }
    }
}